// @flow
/* eslint-disable no-unused-expressions */
import React, { Component } from 'react'
import 'intersection-observer'
import InViewMonitor from 'react-inview-monitor'
import glamorous from 'glamorous'
import { colors } from 'style'

// Cache if we've seen an image before so we don't both with
// lazy-loading & fading in on subsequent mounts.
const imageCache = {}
const inImageCache = src => {
  if (imageCache[src]) {
    return true
  }

  imageCache[src] = true
  return false
}

const VideoPlayer = glamorous('video', {
  forwardProps: ['playsInline', 'muted'],
})(
  {
    position: `absolute`,
    top: 0,
    left: 0,
    width: `100%`,
    height: `100%`,
    objectFit: `cover`,
    objectPosition: `center`,
    transition: `opacity 0.7s`,
  },
  ({ opacity }) => ({
    opacity,
  }),
)

VideoPlayer.defaultProps = {
  autoPlay: true,
  loop: true,
  muted: true,
  playsInline: true,
}

type VideoProps = {
  src: string,
  type: string,
  aspectRatio: number,
  isPlaying?: boolean,
}

type State = {
  videoCanPlay: boolean,
}

class Video extends Component<VideoProps, State> {
  constructor(props) {
    super(props)

    const videoCanPlay = inImageCache(props.src)
    this.state = {
      videoCanPlay,
    }
  }

  componentDidMount() {
    const { isPlaying } = this.props
    isPlaying != null && this.toggleVideo(isPlaying)
    this.videoEl && this.videoEl.addEventListener('canplay', this.handleCanPlay)
  }

  componentDidUpdate(prevProps) {
    const { src, isPlaying } = this.props
    if (prevProps.src !== src) {
      this.videoEl && this.videoEl.load()
    } else if (prevProps.isPlaying !== isPlaying) {
      isPlaying != null && this.toggleVideo(isPlaying)
    }
  }

  componentWillUnmount() {
    this.videoEl &&
      this.videoEl.removeEventListener('canplay', this.handleCanPlay)
  }

  toggleVideo = (isPlaying: boolean) => {
    if (isPlaying) {
      this.videoEl && this.videoEl.play()
    } else {
      this.videoEl && this.videoEl.pause()
    }
  }

  handleCanPlay = () => {
    this.setState({ videoCanPlay: true })
  }

  videoEl: ?HTMLVideoElement

  render() {
    const { src, type, aspectRatio } = this.props
    const { videoCanPlay } = this.state
    return (
      <div style={{ position: 'relative' }}>
        <div
          style={{
            width: `100%`,
            paddingBottom: `${100 / aspectRatio}%`,
            backgroundColor: colors.gray100,
          }}
        />
        <VideoPlayer
          innerRef={el => {
            this.videoEl = el
          }}
          opacity={videoCanPlay ? 1 : 0}
        >
          <source src={src} type={type} />
        </VideoPlayer>
      </div>
    )
  }
}

type Props = {
  src: string,
  contentType: string,
  aspectRatio: number,
}

const Gif = ({ src, contentType, aspectRatio }: Props) => (
  <InViewMonitor
    childPropsInView={{ isPlaying: true }}
    toggleChildPropsOnInView
  >
    <Video src={src} type={contentType} aspectRatio={aspectRatio} />
  </InViewMonitor>
)

export default Gif



// WEBPACK FOOTER //
// ./src/components/Gif.js